const makeMapping = (mapping, errorMessage = (prop) => `Invalid key: '${prop}'`) =>
  new Proxy(Object.freeze(mapping), {
    get(target, prop) {
      if (!(prop in target)) {
        throw new Error(errorMessage(prop));
      }
      return target[prop];
    },
  });

const makeEnum = (mapping, enumName) => {
  const values = Object.values(mapping);
  if (values.length > [...new Set(values)].length) {
    throw new Error('Invalid enum: duplicate values');
  }
  const enumObject = makeMapping(
    {
      ...mapping,
      ALL_ITEMS: Object.values(mapping),
      ...(enumName && { ENUM_NAME: enumName }),
    },
    (prop) => (prop == 'ENUM_NAME' ? 'Enum does not have name' : `Invalid enum value: '${prop}'`),
  );

  return enumObject;
};

export { makeMapping, makeEnum };
